<i18n src='../i18n/main.json'></i18n>
<i18n src='../i18n/clients.json'></i18n>
<template>
<div id="properties" style="position: relative">
  <!-- <flash-message variant="success"></flash-message> -->
  <h1>{{$t('clients')}}</h1>
  <div class="row">
    <button v-on:click="loadClientEditor(null, true)" class="btn btn-warning new">{{$t('new_client')}}</button>
  </div>
  <br>
  <sweet-modal ref="edit_client_modal">
    <h2>{{e_client_new == true ? $t('new_client') : $t('edit') }}</h2>

    <div class="row">

      <div class="form-group col-md-2">
        <label for="e_client_name">{{$t('name')}}</label>
        <input id="e_client_name" v-model="e_client.name" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_client_mobile">{{$t('mobile')}} 1</label>
        <input id="e_client_mobile" v-model="e_client.mobile_1st" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_client_mobile">{{$t('mobile')}} 2</label>
        <input id="e_client_mobile" v-model="e_client.mobile_2nd" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_client_phone">{{$t('phone')}}</label>
        <input id="e_client_phone" v-model="e_client.phone" placeholder="" class="form-control">
      </div>
      <div class="form-group col-md-2">
        <label for="e_client_fax">{{$t('fax')}}</label>
        <input id="e_client_fax" v-model="e_client.fax" placeholder="" class="form-control">
      </div>
      <div class="form-group col-md-2">
        <label for="e_client_tax_number">{{$t('tax_number')}}</label>
        <input id="e_client_tax_number" v-model="e_client.tax_number" placeholder="" class="form-control">
      </div>


    </div>

    <div class="row">

      <div class="form-group col-md-2">
        <label for="e_client_email">{{$t('email')}}</label>
        <input dir="ltr" id="e_client_email" v-model="e_client.email" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-2">
        <label for="e_client_street_address_1st">{{$t('address')}}</label>
        <input id="e_client_street_address_1st" v-model="e_client.address" placeholder="" class="form-control">
      </div>

      <div class="form-group col-md-4">
        <label for="e_client_notes">{{$t('notes')}}</label>
        <input id="e_client_notes" v-model="e_client.notes" placeholder="" class="form-control">
      </div>

    </div>

    <div class="form-group">
      <button class='btn btn-success' v-on:click="save_client">{{$t('save')}}</button>
    </div>
  </sweet-modal>

  <form v-on:submit.prevent class="form-inline">
    <div class="form-group">
      <label class="form-label" for="page_number">تصفح</label>
      <button v-on:click="pagination.page_number -= 1; loadClients();" :disabled="pagination.page_number == 1" class="btn btn-default">-</button>
      <input name="page_number" style="width: 70px;text-align: center;" v-on:keyup="keymonitor" type="text" :max="pagination.total_pages"
        v-model="pagination.page_number" :disabled=PageSelectisDisabled class="form-control center">
      <button v-on:click="pagination.page_number += 1; loadClients();" :disabled="pagination.total_pages == pagination.page_number"
        class="btn btn-default">+</button>
    </div>

    <div class="form-group">
      <label class="form-label" for="filter_name">{{$t('name')}}</label>
      <input id="filter_name" type="text" v-model="filter.name" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_mobile">{{$t('mobile')}}</label>
      <input style="width: 100px;" id="filter_mobile" type="text" v-model="filter.mobile" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_phone">{{$t('phone')}}</label>
      <input style="width: 100px;" id="filter_phone" type="text" v-model="filter.phone" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_email">{{$t('email')}}</label>
      <input style="width: 100px;" id="filter_email" type="text" v-model="filter.email" class="form-control">
    </div>
    <div class="form-group">
      <label class="form-label" for="filter_tax_number">{{$t('tax_number')}}</label>
      <input style="width: 100px;" id="filter_tax_number" type="text" v-model="filter.tax_number" class="form-control">
    </div>

    <!-- <div class="form-group">
      <label class="form-label" for="filter_location_id">{{$t('location')}}</label>
      <select v-model="filter.location_id" class="form-control" id="filter_location_id">
        <option :value="undefined"></option>
        <option v-for="(option, key) in locations" :value="option.id">{{$t(option.name)}}</option>
      </select>
    </div> -->

    <div class="form-group">
      <div class="totalPages">
        {{ totalPages }}
      </div>
    </div>
    <div class="form-group">
      <label class="form-label" for="per_page">{{$t('results_in_each_page')}}</label>
      <select style="width: 100px;" name="per_page" v-model="pagination.per_page" class="form-control center">
        <option disabled value="">נא לבחור אפשרות</option>
        <option>10</option>
        <option>25</option>
        <option>50</option>
        <option>100</option>
      </select>
    </div>
  </form>
  <br />
  <!-- <input type="text" v-model="filter.inserted_at" id="date"> -->
  <!-- <p>רשום במערכת כ- { logged_in_email }</p> -->
  <div style="overflow-x:auto">
    <table class="table listing table-striped">
      <thead>
        <tr class="bg alpha">
          <th style="width:100px;">{{$t('number')}}</th>

          <th>{{$t('name')}}</th>
          <th>{{$t('mobile')}} 1</th>
          <th>{{$t('phone')}}</th>
          <th>@</th>
          <th>{{$t('tax_number')}}</th>
          <!-- <th>{{$t('location')}}</th> -->
          <th>{{$t('notes')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="client of clients" :key="client.id" v-bind:class="{ pending: client.status == 0, approved: client.status == 2 }">
          <td>{{ client.id }}</td>
          <td>
            <i :title="$t('edit')" v-on:click="loadClientEditor(client, false)" class="ti-pencil"></i>
            <span>&rlm;&nbsp;{{ client.name }}</span>
          </td>
          <td>{{ client.mobile_1st }}</td>
          <td>{{ client.phone }}</td>
          <td>
            <a :href="'mailto:' + client.email">{{ client.email }}</a>
          </td>
          <!-- <td>{{ locations.find(x => x.id === client.location_id).name }}</td> -->
          <td>{{ client.tax_number }}</td>
          <td>{{ client.notes }}</td>
        </tr>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue'

export default {
  components: {
    SweetModal
  },
  data() {
    return {
      //  locations: [],
      adding_item: false,
      e_client: [],
      e_client_new: false,
      clients: [],
      errors: [],
      filter: {
        name: '',
        mobile: '',
        phone: '',
        fax: '',
        email: '',
        tax_number: '',
        inserted_at: '2017-10-01'
      },
      filter_objects: [],
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      pagination: {
        page_number: '',
        total_pages: '',
        per_page: '100'
      },
      PageSelectisDisabled: false
    }
  },
  computed: {
    tokenState() {
      return this.$ls.get('access_token')
    },
    totalPages() {
      return this.pagination.total_pages
    },
    Agent() {
      return this.$ls.get('agent')
    },
    locale() {
      return this.$store.getters.locale
    }
  },
  // Fetches posts when the component is created.
  created() {
    this.init()
    this.loadClients()
    this.$i18n.locale = this.$store.getters.locale
    this.$i18n.silentTranslationWarn = true
    this.loadTranslations()
    //this.load_locations()
    //  this.loadFilterObjects()
  },
  watch: {
    locale(locale) {
      this.$i18n.locale = locale
      this.loadTranslations()
    },
    'filter.name': function(val, oldVal) {
      this.loadClients()
    },
    'filter.mobile': function(val, oldVal) {
      this.loadClients()
    },
    'filter.phone': function(val, oldVal) {
      this.loadClients()
    },
    'filter.fax': function(val, oldVal) {
      this.loadClients()
    },
    'filter.email': function(val, oldVal) {
      this.loadClients()
    },
    'filter.tax_number': function(val, oldVal) {
      this.loadClients()
    },
    // 'filter.vendor_id': function(val, oldVal) {
    //   this.loadClients()
    // },
    // 'filter.user_id': function(val, oldVal) {
    //   this.loadClients()
    // },
    // 'pagination.per_page': function(val, oldVal) {
    //   this.loadClients()
    // },
    items: function(val, oldVal) {
      this.PageSelectisDisabled = false
    }
  },

  methods: {
    loadClients: function(e) {
      this.PageSelectisDisabled = true
      this.$axios
        .get(`/api/clients`, {
          headers: this.authorization(),
          params: {
            page: this.pagination.page_number,
            per_page: this.pagination.per_page,
            name: this.filter.name,
            mobile: this.filter.mobile,
            phone: this.filter.phone,
            email: this.filter.email,
            inserted_at: this.filter.inserted_at + ' 00:00:00',
            tax_number: this.filter.tax_number
          }
        })
        .then(response => {
          console.log(response.data)
          // JSON responses are automatically parsed.
          this.clients = response.data.clients.entries

          this.pagination.page_number = response.data.clients.page_number
          this.pagination.total_pages = response.data.clients.total_pages
          if (this.pagination.page_number > this.pagination.total_pages) {
            this.pagination.page_number = 1
            this.loadClients()
          }
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },

    loadClientEditor: function(client, status) {
      this.e_client_new = status
      //this.load_languages()
      if (client == null) {
        client = { name: '', mobile: '' }
      }
      this.e_client = client
      console.log(this.e_client)
      this.$refs.edit_client_modal.open()
    },
    loadTranslations: function() {
      this.click_to_print_sticker = this.$t('click_to_print_sticker')
      this.number_of_results_pages = this.$t('number_of_results_pages')
      this.days_count = this.$t('days_count')
    },
    init: function() {
      //   this.logged_in_email = this.logged_in().as != null ? this.logged_in().as : "Guest"
    },
    keymonitor: function(event) {
      //console.log(event.key)
      if (event.key == 'Enter') {
        this.loadClients()
      }
    },
    save_client: function() {
      this.e_client_new == true ? this.create_client() : this.update_client()
    },
    create_client: function() {
      console.log('create_client..')
      var vm = this
      var client = this.e_client
      this.$axios
        .post(
          `/api/clients`,
          {
            client
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_client_modal.close()
          this.loadClients()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },
    update_client: function() {
      console.log('update_client..')
      var vm = this
      var client = this.e_client
      this.$axios
        .put(
          `/api/clients/` + client.id,
          {
            client
          },
          {
            headers: this.authorization()
          }
        )
        .then(response => {
          console.log(response)
          vm.$refs.edit_client_modal.close()
          this.loadClients()
        })
        .catch(e => {
          this.errors.push(e)
          this.PageSelectisDisabled = false
        })
    },

    loadFilterObjects: function(e) {
      this.$axios
        .get(`/api/clients/filter_objects`, {
          headers: {
            authorization: this.$ls.get('access_token')
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          this.filter_objects = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    updateRow: function(row) {
      var foundIndex = this.properties.findIndex(x => x.id == row.id)
      this.$set(this.properties, foundIndex, row)
    }
  }
}
</script>

<style lang="scss">
@import './sass/clients.scss';
</style>
